import { render, staticRenderFns } from "./SidebarListGroup.vue?vue&type=template&id=106f0b62&scoped=true&"
import script from "./SidebarListGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarListGroup.vue?vue&type=script&lang=js&"
import style0 from "./SidebarListGroup.vue?vue&type=style&index=0&id=106f0b62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106f0b62",
  null
  
)

export default component.exports